import HeroSection from '../src/components/home/HeroSection';
import LearnerSection from '../src/components/home/LearnerSection';
import MentorshipSection from '../src/components/home/MentorshipSection';
import mentorshipPrograms from '../src/data/mentorship-programs.json';
import WorkshopSection from '../src/components/home/WorkshopSection';
import workshops from '../src/data/workshops.json';
// import QuizBanner from '../src/components/home/QuizBanner';
import AdvantageSection from '../src/components/home/AdvantageSection';
import SuccessStories from '../src/components/home/SuccessStories';
import CompaniesSection from '../src/components/home/CompaniesSection';
import TestimonialsSection from '../src/components/home/TestimonialsSection';
import Business from '../src/components/home/Business';
import Investors from '../src/components/home/Investors';
import investorsData from '../src/data/investors.json';
import Cards from '../src/components/home/Cards';
import CommunitySection from '../src/components/home/CommunitySection';
import communityData from '../src/data/communityData.json';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <LearnerSection />
      <MentorshipSection programs={mentorshipPrograms} />
      <WorkshopSection workshops={workshops} />
      {/* <QuizBanner /> */}
      <AdvantageSection />
      <SuccessStories />
      <CompaniesSection />
      <TestimonialsSection />
      <Business />
      <div>
        <CommunitySection communityData={communityData} />
      </div>
      <Cards />
      <Investors investors={investorsData} />
    </main>
  );
}
